(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["comfort-guide"] && !Shopify.designMode) return;
  try {
    (function () {
  var RULES = {"wide|<65|back":{"ff":"F","fam":["ÅBYGDA","ÅSBYGDA"],"sf":"MF","z1":null,"z2":5},"wide|<65|side":{"ff":"MF","fam":["ÅKREHAMN","ÅBROTTEN"],"sf":"MF","z1":5,"z2":7},"wide|<65|stomach":{"ff":"F","fam":["ÅBYGDA","ÅSBYGDA"],"sf":"MF","z1":null,"z2":5},"wide|65-85|back":{"ff":"MF","fam":["ÅNNELAND"],"sf":"F","z1":null,"z2":5},"wide|65-85|side":{"ff":"MF","fam":["ÅNNELAND"],"sf":"F","z1":5,"z2":7},"wide|65-85|stomach":{"ff":"MF","fam":["ÅNNELAND"],"sf":"F","z1":5,"z2":7},"wide|>85|back":{"ff":"F","fam":["ÅNNELAND"],"sf":"XF","z1":7,"z2":5},"wide|>85|side":{"ff":"MF","fam":["ÅNNELAND"],"sf":"F","z1":7,"z2":5},"wide|>85|stomach":{"ff":"F","fam":["ÅNNELAND"],"sf":"XF","z1":7,"z2":5},"average|<65|back":{"ff":"F","fam":["ÅBYGDA","ÅSBYGDA"],"sf":"MF","z1":null,"z2":5},"average|<65|side":{"ff":"MF","fam":["ÅBYGDA","ÅSBYGDA"],"sf":"MF","z1":5,"z2":7},"average|<65|stomach":{"ff":"F","fam":["ÅBYGDA","ÅSBYGDA"],"sf":"MF","z1":null,"z2":5},"average|65-85|back":{"ff":"F","fam":["ÅKREHAMN","ÅBROTTEN"],"sf":"F","z1":5,"z2":7},"average|65-85|side":{"ff":"MF","fam":["ÅKREHAMN","ÅBROTTEN"],"sf":"MF","z1":5,"z2":7},"average|65-85|stomach":{"ff":"F","fam":["ÅKREHAMN","ÅBROTTEN"],"sf":"F","z1":5,"z2":7},"average|>85|back":{"ff":"F","fam":["ÅNNELAND"],"sf":"XF","z1":7,"z2":5},"average|>85|side":{"ff":"F","fam":["ÅKREHAMN","ÅBROTTEN"],"sf":"F","z1":7,"z2":5},"average|>85|stomach":{"ff":"F","fam":["ÅNNELAND"],"sf":"XF","z1":7,"z2":5},"narrow|<65|back":{"ff":"MF","fam":["ÅBYGDA","ÅSBYGDA"],"sf":"MF","z1":null,"z2":5},"narrow|<65|side":{"ff":"MF","fam":["ÅBYGDA","ÅSBYGDA"],"sf":"MF","z1":null,"z2":5},"narrow|<65|stomach":{"ff":"MF","fam":["ÅBYGDA","ÅSBYGDA"],"sf":"MF","z1":null,"z2":5},"narrow|65-85|back":{"ff":"F","fam":["ÅBYGDA","ÅSBYGDA"],"sf":"F","z1":null,"z2":5},"narrow|65-85|side":{"ff":"F","fam":["ÅBYGDA","ÅSBYGDA"],"sf":"MF","z1":null,"z2":5},"narrow|65-85|stomach":{"ff":"F","fam":["ÅBYGDA","ÅSBYGDA"],"sf":"F","z1":null,"z2":5},"narrow|>85|back":{"ff":"F","fam":["ÅKREHAMN","ÅBROTTEN"],"sf":"XF","z1":7,"z2":5},"narrow|>85|side":{"ff":"MF","fam":["ÅKREHAMN","ÅBROTTEN"],"sf":"XF","z1":7,"z2":5},"narrow|>85|stomach":{"ff":"F","fam":["ÅKREHAMN","ÅBROTTEN"],"sf":"XF","z1":7,"z2":5},"wide_hips|<65|back":{"ff":"MF","fam":["ÅKREHAMN","ÅBROTTEN"],"sf":"MF","z1":null,"z2":5},"wide_hips|<65|side":{"ff":"F","fam":["ÅKREHAMN","ÅBROTTEN"],"sf":"F","z1":null,"z2":5},"wide_hips|<65|stomach":{"ff":"MF","fam":["ÅKREHAMN","ÅBROTTEN"],"sf":"MF","z1":null,"z2":5},"wide_hips|65-85|back":{"ff":"MF","fam":["ÅNNELAND"],"sf":"F","z1":null,"z2":5},"wide_hips|65-85|side":{"ff":"MF","fam":["ÅNNELAND"],"sf":"XF","z1":5,"z2":7},"wide_hips|65-85|stomach":{"ff":"MF","fam":["ÅNNELAND"],"sf":"F","z1":null,"z2":5},"wide_hips|>85|back":{"ff":"MF","fam":["ÅNNELAND"],"sf":"XF","z1":7,"z2":5},"wide_hips|>85|side":{"ff":"F","fam":["ÅNNELAND"],"sf":"XF","z1":7,"z2":5},"wide_hips|>85|stomach":{"ff":"MF","fam":["ÅNNELAND"],"sf":"XF","z1":7,"z2":5}};
  // Italy sells IKEA spring mattresses in firm and extra firm only (IKEA's "F-XF" market rule)
  var SPRING_MARKET = { MF: 'F', F: 'F', XF: 'XF' };
  var FIRM_LABEL = { MF: 'Medium firm', F: 'Firm', XF: 'Extra firm' };
  var FIRM_CODE = { 'medium firm': 'MF', 'medium': 'MF', 'firm': 'F', 'extra firm': 'XF', 'soft': 'MF', 'extra soft': 'MF', 'semirigido': 'MF', 'rigido': 'F', 'extra rigido': 'XF' };
  var FIRM_RANK = { MF: 0, F: 1, XF: 2 };
  var POS_LABEL = { back: 'On my back', side: 'On my side', stomach: 'On my stomach' };
  var POS_META = { back: 'Back', side: 'Side', stomach: 'Stomach' };
  var BODY_LABEL = { narrow: 'Narrow', average: 'Average', wide_hips: 'Wide hips', wide: 'Wide' };
  var WEIGHT_LABEL = { '<65': 'Under 65 kg', '65-85': '65 to 85 kg', '>85': 'Over 85 kg' };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function series(title) {
    // IKEA names are the leading UPPERCASE words: "LYCKSELE LÖVÅS mattress …" → "LYCKSELE LÖVÅS"
    var words = String(title || '').split(/\s+/), out = [];
    for (var i = 0; i < words.length; i++) {
      var w = words[i].replace(/[,]/g, '');
      if (w && w === w.toUpperCase() && /[A-ZÅÄÖ]/.test(w)) out.push(w); else break;
    }
    return out.join(' ') || String(title || '').split(',')[0];
  }
  function typeLine(p) {
    var title = String(p.t || ''), name = series(p.t);
    if (!name || name === title) return title.split(/\s[-|]\s/)[0].trim();
    return title.replace(name, '').replace(/^[\s,]+/, '').split(',')[0].trim();
  }
  function isHybrid(p) { return /hybrid|ibrido/i.test(p.t || ''); }
  function sizeKey(p) {
    if (p.w && p.l) return p.w + 'x' + p.l;
    var m = String(p.size || p.t || '').match(/(\d{2,3})\s*x\s*(\d{2,3})/i);
    return m ? m[1] + 'x' + m[2] : '';
  }
  function firmCode(p) { return FIRM_CODE[String(p.firm || '').toLowerCase()] || null; }
  function isSpring(p) { return /spring|molle/i.test(p.mat || '') || /spring|sprung/i.test(p.t || ''); }
  function isMemory(p) { return /memory/i.test(p.mat || '') || /memory/i.test(p.t || ''); }
  function has(arr, v) { return Array.isArray(arr) && arr.indexOf(v) !== -1; }

  function parseWsLines(text) {
    var lines = {};
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var parts = line.split('|');
      if (parts.length < 2) return;
      var tag = parts[0].trim();
      if (!tag) return;
      lines[tag.toUpperCase()] = {
        tag: tag,
        firm: FIRM_CODE[(parts[1] || '').trim().toLowerCase()] || 'MF',
        zones: parseInt(parts[2], 10) || 0,
        pos: (parts[3] || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean),
        blurb: (parts[4] || '').trim(),
        badge: (parts[5] || '').trim()
      };
    });
    return lines;
  }

  function badgeFor(p) {
    if (isMemory(p)) return 'Pressure relief';
    if (isSpring(p)) return 'Targeted support';
    return 'Comfort & support';
  }
  function whyIkea(p, firm) {
    var name = series(p.t), zones = p.z ? ' The ' + p.z + ' comfort zones give shoulders and hips a softer landing.' : '';
    var f = FIRM_LABEL[firm] ? FIRM_LABEL[firm].toLowerCase() : '';
    if (isHybrid(p) || (isSpring(p) && isMemory(p))) return 'We chose ' + name + ' in ' + f + ' because it pairs pocket springs with a memory-foam top: the responsiveness of springs with the pressure relief of foam.' + zones;
    if (isSpring(p)) return 'We chose ' + name + ' in ' + f + ' because pocket springs respond to your movements without disturbing the person next to you.' + (zones || ' Ideal if you tend to move around a lot in your sleep.');
    if (isMemory(p)) return 'We chose ' + name + ' in ' + f + ' because soft foam and memory foam together relieve pressure and follow the shape of your body.' + zones;
    return 'We chose ' + name + ' in ' + f + ' because its foam layers work together: support underneath, comfort on top.' + zones;
  }

  function init(root) {
    var products, cfg;
    try {
      products = JSON.parse(root.querySelector('[data-cg-products]').textContent || '[]');
      cfg = JSON.parse(root.querySelector('[data-cg-config]').textContent || '{}');
    } catch (e) { return; }
    var wsLines = parseWsLines(cfg.wsLines);
    var state = { position: null, body: null, weight: null, size: '' };
    var stages = { questions: root.querySelector('[data-cg-stage="questions"]'), results: root.querySelector('[data-cg-stage="results"]') };
    var steps = { position: root.querySelector('[data-cg-step="position"]'), body: root.querySelector('[data-cg-step="body"]'), weight: root.querySelector('[data-cg-step="weight"]') };
    var toastEl = root.querySelector('[data-cg-toast]');

    // ---------- pools
    var ikea = products.filter(function (p) { return p.k === 'mattress' && firmCode(p); });
    var ws = products.filter(function (p) { return p.k === 'ws'; });
    var toppers = products.filter(function (p) { return p.k === 'topper' && !/protector/i.test(p.t); });
    ws.forEach(function (p) {
      var line = null;
      (p.tags || []).forEach(function (t) { if (wsLines[String(t).toUpperCase()]) line = wsLines[String(t).toUpperCase()]; });
      p.line = line;
      if ((p.tags || []).some(function (t) { return String(t).toUpperCase() === 'TOPPER'; })) { p.k = 'topper'; toppers.push(p); }
    });
    ws = ws.filter(function (p) { return p.k === 'ws' && p.line; });
    var pillows = products.filter(function (p) { return p.k === 'pillow'; });

    // IKEA mattresses grouped by series + firmness (each size is its own product)
    function groupIkea(list) {
      var groups = {};
      list.forEach(function (p) {
        var key = series(p.t) + '|' + firmCode(p);
        if (!groups[key]) groups[key] = { key: key, name: series(p.t), firm: firmCode(p), items: [] };
        groups[key].items.push(p);
      });
      return Object.keys(groups).map(function (k) {
        var g = groups[k];
        g.items.sort(function (a, b) { return (a.w || 0) - (b.w || 0) || (a.l || 0) - (b.l || 0) || a.price - b.price; });
        g.rep = g.items.filter(function (p) { return p.a; })[0] || g.items[0];
        g.min = g.items.reduce(function (m, p) { return p.price < m.price ? p : m; }, g.items[0]);
        g.zones = g.rep.z == null ? null : Number(g.rep.z);
        g.spring = isSpring(g.rep);
        g.memory = isMemory(g.rep);
        g.hybrid = isHybrid(g.rep);
        return g;
      });
    }
    var ikeaGroups = groupIkea(ikea);
    var topperGroups = groupIkea(toppers.filter(function (p) { return p.k === 'topper' && p.v !== 'The White Stone'; }).map(function (p) { p.firm = p.firm || 'n/a'; return p; }));

    // ---------- recommendation
    function recommend() {
      var rule = RULES[state.body + '|' + state.weight + '|' + state.position];
      if (!rule) return null;
      var springFirm = SPRING_MARKET[rule.sf], foamFirm = rule.ff;
      var picks = [];

      // 1. IKEA pocket-spring pick: firmness (market-mapped) then comfort zones (primary, then secondary)
      var springs = ikeaGroups.filter(function (g) { return g.spring && !g.hybrid && rule.fam.indexOf(g.name) === -1; });
      var spring = pickBy(springs, springFirm, [rule.z1, rule.z2]);
      if (spring) picks.push({ group: spring, why: whyIkea(spring.rep, spring.firm), badge: badgeFor(spring.rep) });

      // 2. IKEA foam / hybrid pick: IKEA's family for this profile, else any non-spring family at that firmness
      var foams = ikeaGroups.filter(function (g) { return !g.spring || g.hybrid || rule.fam.indexOf(g.name) !== -1; });
      var foam = null;
      for (var i = 0; i < rule.fam.length && !foam; i++) {
        foam = foams.filter(function (g) { return g.name === rule.fam[i] && g.firm === foamFirm; })[0];
      }
      if (!foam) foam = pickBy(foams.filter(function (g) { return !spring || g.key !== spring.key; }), foamFirm, [rule.z1, rule.z2]);
      if (foam && (!spring || foam.key !== spring.key)) picks.push({ group: foam, why: whyIkea(foam.rep, foam.firm), badge: badgeFor(foam.rep) });

      // 3. The White Stone pick: line whose positions include ours, closest firmness, zones when wanted
      var target = FIRM_RANK[foamFirm];
      var best = null, bestScore = -1;
      ws.forEach(function (p) {
        var L = p.line, score = 0;
        if (L.pos.indexOf(POS_META[state.position]) !== -1) score += 3;
        score += 2 - Math.min(2, Math.abs(FIRM_RANK[L.firm] - target));
        if (rule.z1 && L.zones) score += 1;
        if (L.pos.length <= 2) score += 0.5;           // a line made for this position beats an all-rounder
        if (state.position === 'side' && /memory/i.test(L.tag)) score += 0.5;
        if (!p.a) score -= 1;
        if (score > bestScore) { bestScore = score; best = p; }
      });
      if (best) {
        var line = best.line;
        var siblings = ws.filter(function (p) { return p.line === line; }).sort(function (a, b) { return a.price - b.price; });
        picks.push({ ws: true, line: line, items: siblings, rep: siblings[0], why: line.blurb, badge: line.badge || (line.zones ? line.zones + ' comfort zones' : (line.firm === 'F' ? 'Firm support' : 'Pressure relief')) });
      }

      return { rule: rule, springFirm: springFirm, foamFirm: foamFirm, picks: picks };
    }

    function pickBy(groups, firm, zonesPref) {
      var pool = groups.filter(function (g) { return g.firm === firm; });
      if (!pool.length) {
        // nearest firmness
        var rank = FIRM_RANK[firm];
        pool = groups.slice().sort(function (a, b) { return Math.abs(FIRM_RANK[a.firm] - rank) - Math.abs(FIRM_RANK[b.firm] - rank); });
        if (!pool.length) return null;
        var nearest = pool[0].firm;
        pool = pool.filter(function (g) { return g.firm === nearest; });
      }
      function zoneScore(g) {
        var z = g.zones == null ? 0 : g.zones;
        if (zonesPref[0] === z || (zonesPref[0] === null && z === 0)) return 2;
        if (zonesPref[1] === z || (zonesPref[1] === null && z === 0)) return 1;
        return 0;
      }
      pool.sort(function (a, b) {
        return zoneScore(b) - zoneScore(a) || (b.rep.a ? 1 : 0) - (a.rep.a ? 1 : 0) || a.min.price - b.min.price;
      });
      return pool[0] || null;
    }

    function pickPillows() {
      var want = POS_META[state.position];
      var list = pillows.filter(function (p) { return has(p.pos, want); });
      list.sort(function (a, b) {
        function score(p) {
          var s = 0;
          if (has(p.feat, 'Ergonomic')) s += 2;
          if (has(p.feat, 'Cooling')) s += 1;
          if (p.a) s += 1;
          return s;
        }
        return score(b) - score(a) || a.price - b.price;
      });
      return list.slice(0, cfg.maxPillows || 4);
    }

    function pickToppers() {
      var groups = topperGroups.slice();
      var wsToppers = toppers.filter(function (p) { return p.v === 'The White Stone'; });
      wsToppers.forEach(function (p) { groups.push({ key: 'ws|' + p.h, name: 'The White Stone', ws: true, items: [p], rep: p, min: p, memory: true }); });
      function score(g) {
        var s = 0;
        if (state.position === 'side' && g.memory) s += 2;
        if (state.position !== 'side' && !g.memory) s += 1;
        if (state.size && g.items.some(function (p) { return sizeKey(p) === state.size; })) s += 2;
        if (g.rep.a) s += 1;
        return s;
      }
      groups.sort(function (a, b) { return score(b) - score(a) || a.min.price - b.min.price; });
      return groups.slice(0, cfg.maxToppers || 3);
    }

    // ---------- rendering
    function money(p, item) { return item ? item.pf : p.pf; }
    function cardIkea(pick) {
      var g = pick.group, rep = g.rep;
      var sizes = g.items.map(function (p, i) {
        var label = (p.size || sizeKey(p) || typeLine(p)) + ' — ' + p.pf + (p.a ? '' : ' (sold out)');
        return '<option value="' + i + '"' + (sizeKey(p) === state.size ? ' selected' : '') + '>' + esc(label) + '</option>';
      }).join('');
      var chips = [];
      if (FIRM_LABEL[g.firm]) chips.push(FIRM_LABEL[g.firm]);
      if (g.zones) chips.push(g.zones + ' comfort zones'); else if (g.zones === 0) chips.push('No comfort zones');
      if (rep.mat) chips.push(rep.mat);
      if (rep.th) chips.push('Thickness ' + rep.th + ' cm');
      return card({
        brand: 'IKEA', badge: pick.badge, img: rep.img, name: g.name, type: typeLine(rep), url: rep.url,
        from: g.items.length > 1, price: g.min.pf, cap: g.min.cap > g.min.price ? g.min.cap : 0,
        chips: chips, why: pick.why, selectLabel: 'Select size', options: sizes,
        data: { kind: 'ikea', key: g.key }
      });
    }
    function cardWs(pick) {
      var rep = pick.rep;
      var heights = pick.items.map(function (p, i) {
        var m = String(p.t).match(/height\s*(\d+)\s*cm/i);
        return '<option value="' + i + '">' + esc(m ? 'Height ' + m[1] + ' cm' : typeLine(p)) + ' — from ' + esc(p.pf) + '</option>';
      }).join('');
      var chips = [FIRM_LABEL[pick.line.firm]];
      if (pick.line.zones) chips.push(pick.line.zones + ' comfort zones');
      if (/memory/i.test(pick.line.tag)) chips.push('Memory foam'); else if (/evolution/i.test(pick.line.tag)) chips.push('Pocket springs'); else chips.push('Water foam');
      chips.push('Made to order');
      return card({
        brand: 'The White Stone', badge: pick.badge, img: rep.img, name: 'The White Stone ' + pick.line.tag.charAt(0) + pick.line.tag.slice(1).toLowerCase(), type: typeLine(rep), url: rep.url,
        from: true, price: rep.pf, cap: 0, chips: chips, why: pick.why,
        selectLabel: 'Select height', options: heights, select2Label: 'Select size', options2: wsSizeOptions(rep),
        data: { kind: 'ws', tag: pick.line.tag }
      });
    }
    function wsSizeOptions(p) {
      return (p.vars || []).map(function (v, i) {
        var k = String(v.t).replace(/\s+/g, '').toLowerCase();
        return '<option value="' + i + '"' + (state.size && k === state.size.toLowerCase() ? ' selected' : '') + '>' + esc(v.t + ' — ' + v.pf + (v.a ? '' : ' (sold out)')) + '</option>';
      }).join('');
    }
    function cardTopper(g) {
      var rep = g.rep;
      if (g.ws) {
        return card({
          brand: 'The White Stone', badge: 'Pressure relief', img: rep.img, name: 'The White Stone Topper', type: typeLine(rep), url: rep.url,
          from: true, price: rep.pf, cap: 0, chips: ['Memory foam', 'Made to order'], why: 'A 5 cm memory-foam layer that softens a mattress that feels too firm and eases pressure on hips and shoulders.',
          selectLabel: 'Select size', options: wsSizeOptions(rep), data: { kind: 'wsvar', h: rep.h }
        });
      }
      var sizes = g.items.map(function (p, i) {
        return '<option value="' + i + '"' + (sizeKey(p) === state.size ? ' selected' : '') + '>' + esc((p.size || sizeKey(p)) + ' — ' + p.pf + (p.a ? '' : ' (sold out)')) + '</option>';
      }).join('');
      var chips = [];
      if (rep.mat) chips.push(rep.mat);
      if (rep.th) chips.push('Thickness ' + rep.th + ' cm');
      var why = g.memory ? 'Memory foam moulds to your body and relieves pressure points — a good upgrade for side sleepers.' : 'Adds a layer of comfort on top and protects the mattress. Easy to air and turn.';
      return card({
        brand: 'IKEA', badge: g.memory ? 'Pressure relief' : 'Extra comfort', img: rep.img, name: g.name, type: typeLine(rep), url: rep.url,
        from: g.items.length > 1, price: g.min.pf, cap: 0, chips: chips, why: why,
        selectLabel: 'Select size', options: sizes, data: { kind: 'ikea', key: g.key }
      });
    }
    function cardPillow(p) {
      var chips = (p.feat || []).slice(0, 3);
      if (p.size) chips.push(p.size);
      var why = has(p.feat, 'Ergonomic') ? 'Shaped to support the neck and keep the head level in your sleeping position.' :
        (has(p.feat, 'Low pillow') ? 'A low pillow keeps the neck relaxed when you sleep on your stomach.' : 'A higher pillow fills the gap between shoulder and head so the neck stays straight.');
      return card({
        brand: 'IKEA', badge: has(p.feat, 'Cooling') ? 'Cooling' : (has(p.feat, 'Ergonomic') ? 'Ergonomic' : ''), img: p.img, name: series(p.t), type: typeLine(p), url: p.url,
        from: false, price: p.pf, cap: p.cap > p.price ? p.cap : 0, chips: chips, why: why, data: { kind: 'single', h: p.h }
      });
    }
    function card(o) {
      var dataAttrs = Object.keys(o.data || {}).map(function (k) { return ' data-' + k + '="' + esc(o.data[k]) + '"'; }).join('');
      return '<article class="cg-card"' + dataAttrs + '>' +
        '<div class="cg-card__media">' + (o.img ? '<img src="' + esc(o.img) + '" alt="' + esc(o.name) + '" loading="lazy">' : '') +
        (o.badge ? '<span class="cg-card__badge">' + esc(o.badge) + '</span>' : '') +
        '<span class="cg-card__brand">' + esc(o.brand) + '</span></div>' +
        '<div class="cg-card__body">' +
        '<h3 class="cg-card__name"><a href="' + esc(o.url) + '" data-cg-link>' + esc(o.name) + '</a></h3>' +
        '<p class="cg-card__type">' + esc(o.type) + '</p>' +
        '<p class="cg-card__price"><span data-cg-price>' + (o.from ? '<small>From</small>' : '') + esc(o.price) + '</span>' + (o.cap ? '<del>' + esc(formatCents(o.cap, o.price)) + '</del>' : '') + '</p>' +
        (o.chips && o.chips.length ? '<ul class="cg-card__chips">' + o.chips.map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('') + '</ul>' : '') +
        (o.why ? '<p class="cg-card__why"><strong>Our recommendation</strong>' + esc(o.why) + '</p>' : '') +
        (o.options ? '<label class="cg-card__select">' + esc(o.selectLabel || 'Select') + '<select data-cg-select="1">' + o.options + '</select></label>' : '') +
        (o.options2 ? '<label class="cg-card__select">' + esc(o.select2Label || 'Select') + '<select data-cg-select="2">' + o.options2 + '</select></label>' : '') +
        '<div class="cg-card__actions"><button type="button" class="cg-card__add" data-cg-add>Add to bag</button>' +
        '<a class="cg-card__link" href="' + esc(o.url) + '" data-cg-link>Details</a></div>' +
        '</div></article>';
    }
    function formatCents(cents, sample) {
      // mimic the formatted sample ("€ 245,99" / "€245.99") for the compare-at price
      var num = (cents / 100).toFixed(2);
      var m = String(sample).match(/^([^\d]*)(\d[\d.,]*)(.*)$/);
      if (!m) return num;
      var dec = m[2].indexOf(',') > m[2].indexOf('.') ? ',' : '.';
      var thou = dec === ',' ? '.' : ',';
      var parts = num.split('.');
      return m[1] + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou) + dec + parts[1] + m[3];
    }

    // Resolve the product/variant a card currently points at
    function resolveCard(cardEl) {
      var kind = cardEl.getAttribute('data-kind');
      var sel1 = cardEl.querySelector('[data-cg-select="1"]');
      var sel2 = cardEl.querySelector('[data-cg-select="2"]');
      if (kind === 'ikea') {
        var g = ikeaGroups.concat(topperGroups).filter(function (x) { return x.key === cardEl.getAttribute('data-key'); })[0];
        var p = g.items[parseInt(sel1 ? sel1.value : 0, 10) || 0];
        return { p: p, v: p.vars[0], pf: p.pf, url: p.url, a: p.a && p.vars[0].a };
      }
      if (kind === 'ws') {
        var line = wsLines[String(cardEl.getAttribute('data-tag')).toUpperCase()];
        var items = ws.filter(function (x) { return x.line === line; }).sort(function (a, b) { return a.price - b.price; });
        var wp = items[parseInt(sel1 ? sel1.value : 0, 10) || 0];
        var v = wp.vars[parseInt(sel2 ? sel2.value : 0, 10) || 0];
        return { p: wp, v: v, pf: v.pf, url: wp.url + '?variant=' + v.id, a: v.a };
      }
      if (kind === 'wsvar') {
        var tp = products.filter(function (x) { return x.h === cardEl.getAttribute('data-h'); })[0];
        var tv = tp.vars[parseInt(sel1 ? sel1.value : 0, 10) || 0];
        return { p: tp, v: tv, pf: tv.pf, url: tp.url + '?variant=' + tv.id, a: tv.a };
      }
      var sp = products.filter(function (x) { return x.h === cardEl.getAttribute('data-h'); })[0];
      return { p: sp, v: sp.vars[0], pf: sp.pf, url: sp.url, a: sp.a };
    }
    function refreshCard(cardEl) {
      var r = resolveCard(cardEl);
      var priceEl = cardEl.querySelector('[data-cg-price]');
      var sel1 = cardEl.querySelector('[data-cg-select="1"]');
      if (priceEl && sel1) priceEl.innerHTML = esc(r.pf);
      cardEl.querySelectorAll('[data-cg-link]').forEach(function (a) { a.href = r.url; });
      var btn = cardEl.querySelector('[data-cg-add]');
      btn.disabled = !r.a;
      btn.textContent = r.a ? 'Add to bag' : 'Sold out';
      if (cardEl.getAttribute('data-kind') === 'ws' && sel1 && cardEl.querySelector('[data-cg-select="2"]') && sel1.dataset.last !== sel1.value) {
        sel1.dataset.last = sel1.value;
        cardEl.querySelector('[data-cg-select="2"]').innerHTML = wsSizeOptions(r.p);
        refreshCard(cardEl);
      }
    }

    function renderResults() {
      var rec = recommend();
      var mattressPanel = root.querySelector('[data-cg-panel="mattresses"]');
      var topperPanel = root.querySelector('[data-cg-panel="toppers"]');
      var pillowPanel = root.querySelector('[data-cg-panel="pillows"]');
      var empty = root.querySelector('[data-cg-empty]');
      var pl = pickPillows(), tp = pickToppers();

      mattressPanel.innerHTML = rec ? rec.picks.map(function (pk) { return pk.ws ? cardWs(pk) : cardIkea(pk); }).join('') : '';
      if (topperPanel) topperPanel.innerHTML = tp.map(cardTopper).join('');
      if (pillowPanel) pillowPanel.innerHTML = pl.map(cardPillow).join('');
      empty.hidden = !!(rec && rec.picks.length);
      setCount('mattresses', rec ? rec.picks.length : 0);
      setCount('toppers', tp.length);
      setCount('pillows', pl.length);
      root.querySelectorAll('.cg-card').forEach(refreshCard);

      // summary + analysis
      var firmText = rec ? FIRM_LABEL[rec.springFirm].toLowerCase() : '';
      var zonesText = rec && rec.rule.z1 ? ' with ' + rec.rule.z1 + ' comfort zones' : (rec ? ' without comfort zones' : '');
      root.querySelector('[data-cg-summary]').textContent = rec ? 'We recommend a ' + firmText + ' mattress' + zonesText + ' for you. Pick a recommendation below to choose your size.' : '';
      root.querySelector('[data-cg-ans="position"]').textContent = POS_LABEL[state.position] || '';
      root.querySelector('[data-cg-ans="body"]').textContent = BODY_LABEL[state.body] || '';
      root.querySelector('[data-cg-ans="weight"]').textContent = WEIGHT_LABEL[state.weight] || '';
      var copy = cfg.copy || {};
      var analysis = '<p>' + esc(copy[state.position] || '') + '</p>';
      if (rec) analysis += '<p><strong>' + esc(FIRM_LABEL[rec.springFirm] + (rec.rule.z1 ? ' with comfort zones.' : '.')) + '</strong> ' + esc(rec.rule.z1 ? 'Comfort zones are softer at the shoulders and hips and firmer where you need support.' : 'An even surface that supports the whole body the same way.') + '</p>';
      analysis += '<p>' + esc(copy['pillow' + state.position.charAt(0).toUpperCase() + state.position.slice(1)] || '') + '</p>';
      root.querySelector('[data-cg-analysis]').innerHTML = analysis;

      showTab('mattresses');
      stages.questions.hidden = true;
      stages.results.hidden = false;
      try { history.replaceState(null, '', '#' + [state.position, state.body, state.weight].join('/')); } catch (e) {}
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function setCount(name, n) { var el = root.querySelector('[data-cg-count="' + name + '"]'); if (el) el.textContent = '(' + n + ')'; }
    function showTab(name) {
      root.querySelectorAll('[data-cg-tab]').forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-cg-tab') === name ? 'true' : 'false'); });
      root.querySelectorAll('[data-cg-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-cg-panel') !== name; });
    }

    // ---------- questions flow
    function showStep(name) {
      Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== name; });
      var h = steps[name].querySelector('.cg__step-title');
      if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    }
    root.querySelectorAll('[data-cg-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.getAttribute('data-cg-pick');
        state[q] = btn.getAttribute('data-value');
        btn.parentNode.querySelectorAll('[data-cg-pick]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        if (q === 'position') showStep('body');
        else if (q === 'body') showStep('weight');
        else renderResults();
      });
    });
    root.querySelectorAll('[data-cg-back]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.closest('[data-cg-step]').getAttribute('data-cg-step');
        showStep(step === 'weight' ? 'body' : 'position');
      });
    });
    root.querySelector('[data-cg-restart]').addEventListener('click', function () {
      state = { position: null, body: null, weight: null, size: '' };
      root.querySelectorAll('[data-cg-pick]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      stages.results.hidden = true;
      stages.questions.hidden = false;
      showStep('position');
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    root.querySelectorAll('[data-cg-tab]').forEach(function (t) { t.addEventListener('click', function () { showTab(t.getAttribute('data-cg-tab')); }); });

    // card interactions (delegated)
    root.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-cg-select]');
      if (!sel) return;
      var cardEl = sel.closest('.cg-card');
      refreshCard(cardEl);
      var r = resolveCard(cardEl);
      var k = sizeKey(r.p) || String(r.v.t || '').replace(/\s+/g, '');
      if (k && cardEl.closest('[data-cg-panel="mattresses"]')) {
        state.size = k;
        // keep toppers in step with the chosen mattress size
        var topperPanel = root.querySelector('[data-cg-panel="toppers"]');
        if (topperPanel) { topperPanel.innerHTML = pickToppers().map(cardTopper).join(''); topperPanel.querySelectorAll('.cg-card').forEach(refreshCard); }
      }
    });
    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-cg-add]');
      if (!btn || btn.disabled) return;
      var cardEl = btn.closest('.cg-card');
      var r = resolveCard(cardEl);
      addToCart(r.v.id, btn);
    });

    function addToCart(variantId, btn) {
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      var body = { items: [{ id: variantId, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname };
      fetch(cfg.cartAddUrl || '/cart/add', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (res) {
        btn.disabled = false; btn.textContent = label;
        if (res.status && res.status !== 200) { toast(res.description || res.message || 'Could not add to bag'); return; }
        // Mirror the theme's own product form: announce the change, then let the drawer re-render itself
        try { if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId, cartData: res }); } catch (err) {}
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          try { drawer.classList.remove('is-empty'); drawer.renderContents(res); return; } catch (err) {}
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && res.sections && res.sections['cart-icon-bubble']) {
          var tmp = document.createElement('div'); tmp.innerHTML = res.sections['cart-icon-bubble'];
          var inner = tmp.querySelector('.shopify-section') || tmp;
          bubble.innerHTML = inner.innerHTML;
        }
        toast('Added to your bag. <a href="' + esc(cfg.cartUrl || '/cart') + '">View bag</a>');
      }).catch(function () { btn.disabled = false; btn.textContent = label; toast('Could not add to bag. Please try again.'); });
    }
    var toastTimer;
    function toast(html) {
      toastEl.innerHTML = html; toastEl.hidden = false;
      clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.hidden = true; }, 4500);
    }

    // deep link: #side/average/65-85
    var hash = decodeURIComponent(location.hash || '').replace('#', '').split('/');
    if (hash.length === 3 && POS_LABEL[hash[0]] && BODY_LABEL[hash[1]] && WEIGHT_LABEL[hash[2]]) {
      state.position = hash[0]; state.body = hash[1]; state.weight = hash[2];
      root.querySelectorAll('[data-cg-pick]').forEach(function (b) {
        if (state[b.getAttribute('data-cg-pick')] === b.getAttribute('data-value')) b.setAttribute('aria-pressed', 'true');
      });
      renderResults();
    }
    // expose for tests
    root.cgRecommend = function (pos, body, weight) { state.position = pos; state.body = body; state.weight = weight; return recommend(); };
  }

  document.querySelectorAll('.cg').forEach(init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ms-gift-card-designer"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var api = String(root.dataset.api || '').replace(/\/+$/, ''), token = root.dataset.token || '';
    var $ = function (sel) { return root.querySelector(sel); };
    var state = { amount: 50, occasion: 'birthday', greeting: '', greetingTouched: false, recipientName: '', fromName: '', message: '',
      description: '', mode: 'classic', designs: [], designId: null, left: 0, signedIn: false, send: true, recipientEmail: '', sendOn: '',
      config: null, busy: false };

    function el(tag, attrs, text) { var e = document.createElement(tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (text != null) e.textContent = text; return e; }
    function occasion() { return (state.config.occasions || []).filter(function (o) { return o.key === state.occasion; })[0]; }
    function showError(msg) { var e = $('[data-error]'); e.textContent = msg || ''; e.hidden = !msg; }
    function money(n) { return '€' + n; }
    // Same rule as the worker's greetingLine(): "Happy birthday" + "Ivan" → "Happy birthday Ivan".
    function greetingLine(greeting, name) {
      var g = String(greeting || '').trim(), n = String(name || '').trim();
      if (!n) return g;
      if (!g) return n;
      if (g.toLowerCase().indexOf(n.toLowerCase()) !== -1) return g;
      return /\bsomething$/i.test(g) ? g + ' for ' + n : g + ' ' + n;
    }

    // ---- preview: the same layout as the picture the worker draws, scaled to the frame
    function fit() { var f = $('.msgc__frame'), c = $('[data-card]'); if (f && c) c.style.transform = 'scale(' + (f.clientWidth / 1200) + ')'; }
    if (window.ResizeObserver) new ResizeObserver(fit).observe($('.msgc__frame')); else window.addEventListener('resize', fit);
    function render() {
      var o = occasion();
      var greeting = state.greeting || (o && o.greeting) || '';
      $('[data-out="amount"]').textContent = money(state.amount || 0);
      $('[data-out="total"]').textContent = state.amount ? money(state.amount) : '';
      var line = greetingLine(greeting, state.recipientName);
      var gEl = $('[data-out="greeting"]');
      gEl.textContent = line;
      gEl.dataset.size = line.length <= 22 ? 'l' : line.length <= 32 ? 'm' : line.length <= 60 ? 's' : 'xs';
      var msg = $('[data-out="message"]'); msg.textContent = state.message;
      var n = state.message.length;
      msg.dataset.size = n > 200 ? 'xs' : n > 120 ? 's' : n > 60 ? 'm' : 'l';
      var fromLine = state.fromName ? 'From ' + state.fromName : '';
      var nEl = $('[data-out="names"]');
      nEl.textContent = fromLine;
      nEl.dataset.size = fromLine.length > 50 ? 's' : 'l';
      var art = $('[data-art]');
      var d = state.mode === 'ai' && state.designs.filter(function (x) { return x.designId === state.designId; })[0];
      var src = d ? d.artUrl : (o && o.classicUrl);
      if (src && art.getAttribute('src') !== src) art.setAttribute('src', src);
      root.querySelectorAll('[data-amounts] .msgc__chip').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.value === state.amount)); });
      root.querySelectorAll('[data-occasions] .msgc__chip').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.value === state.occasion)); });
      root.querySelectorAll('.msgc__tab').forEach(function (t) { t.setAttribute('aria-selected', String(t.dataset.mode === state.mode)); });
      root.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.dataset.panel !== state.mode; });
      $('[data-ai-guest]').hidden = state.signedIn; $('[data-ai-member]').hidden = !state.signedIn;
      $('[data-left]').textContent = state.left > 0 ? (state.left + ' of ' + state.config.allowancePerMonth + ' free AI designs left this month.') : 'You have used your free AI designs this month. Pick one of your designs, or use a classic design.';
      $('[data-generate]').disabled = state.busy || state.left <= 0;
      $('[data-submit]').disabled = state.busy;
      $('[data-busy]').hidden = !state.busy;
      $('[data-count]').textContent = state.message.length + '/300';
      $('[data-send-fields]').hidden = !state.send; $('[data-self-hint]').hidden = state.send;
      var thumbs = $('[data-thumbs]'); thumbs.innerHTML = '';
      state.designs.forEach(function (x, i) {
        var b = el('button', { type: 'button', class: 'msgc__thumb', 'aria-pressed': String(state.mode === 'ai' && x.designId === state.designId), 'aria-label': 'Use AI design ' + (i + 1) });
        b.appendChild(el('img', { src: x.artUrl, alt: '', loading: 'lazy' }));
        b.addEventListener('click', function () { state.mode = 'ai'; state.designId = x.designId; render(); });
        thumbs.appendChild(b);
      });
      $('[data-designs]').hidden = state.designs.length === 0;
      fit();
    }

    function call(path, opts) {
      opts = opts || {};
      var headers = { 'Content-Type': 'application/json' };
      if (token) headers['X-Customer-Token'] = token;
      return fetch(api + path, { method: opts.body ? 'POST' : 'GET', headers: headers, body: opts.body ? JSON.stringify(opts.body) : undefined })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { j._status = r.status; return j; }); });
    }

    function buildChips() {
      var amounts = $('[data-amounts]');
      state.config.amounts.presets.forEach(function (a) {
        var b = el('button', { type: 'button', class: 'msgc__chip', 'data-value': a }, money(a));
        b.addEventListener('click', function () { state.amount = a; $('[data-amount-input]').value = ''; render(); });
        amounts.appendChild(b);
      });
      var occ = $('[data-occasions]');
      state.config.occasions.forEach(function (o) {
        var b = el('button', { type: 'button', class: 'msgc__chip', 'data-value': o.key }, o.label);
        b.addEventListener('click', function () {
          state.occasion = o.key;
          if (!state.greetingTouched) { state.greeting = o.greeting; $('[data-field="greeting"]').value = o.greeting; }
          render();
        });
        occ.appendChild(b);
      });
    }

    // Read what is in the fields right now. A visitor can type before the
    // settings have loaded (David, 18 Oct 2026: "Other amount" 400 but the button said €50).
    function readFields() {
      root.querySelectorAll('[data-field]').forEach(function (input) { state[input.dataset.field] = input.value; });
      var o = occasion();
      if (o && state.greeting && state.greeting !== o.greeting) state.greetingTouched = true;
      var v = $('[data-amount-input]').value.trim();
      if (v !== '') state.amount = /^\d{1,4}$/.test(v) ? +v : 0;
      state.send = $('[data-send]').checked;
    }

    function bind() {
      root.querySelectorAll('[data-field]').forEach(function (input) {
        input.addEventListener('input', function () {
          state[input.dataset.field] = input.value;
          if (input.dataset.field === 'greeting') state.greetingTouched = true;
          render();
        });
      });
      ['input', 'change'].forEach(function (type) {
        $('[data-amount-input]').addEventListener(type, function (e) {
          var v = e.target.value.trim();
          state.amount = /^\d{1,4}$/.test(v) ? +v : 0;  // emptied by hand: no amount until a chip or a number is chosen
          render();
        });
      });
      root.querySelectorAll('.msgc__tab').forEach(function (t) {
        t.addEventListener('click', function () {
          state.mode = t.dataset.mode;
          if (state.mode === 'ai' && !state.designId && state.designs[0]) state.designId = state.designs[0].designId;
          render();
        });
      });
      $('[data-send]').addEventListener('change', function (e) { state.send = e.target.checked; render(); });
      $('[data-generate]').addEventListener('click', generate);
      $('[data-form]').addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
      var today = new Date(), max = new Date(Date.now() + 90 * 864e5);
      var iso = function (d) { return d.toISOString().slice(0, 10); };
      $('[data-field="sendOn"]').min = iso(today); $('[data-field="sendOn"]').max = iso(max);
    }

    function generate() {
      readFields(); render();
      showError('');
      state.busy = true; render();
      call('/api/generate', { body: { occasion: state.occasion, description: state.description, greeting: state.greeting,
        recipientName: state.recipientName, fromName: state.fromName, message: state.message } })
        .then(function (j) {
          state.busy = false;
          if (j._status === 200) {
            state.designs.unshift({ designId: j.designId, artUrl: j.artUrl });
            state.designId = j.designId; state.left = j.left; state.mode = 'ai';
          } else if (j._status === 401) {
            showError('Your sign-in has expired. Please reload the page and try again.');
          } else {
            if (j.error === 'allowance') state.left = 0;
            showError(j.message || 'Something went wrong. Please try again.');
          }
          render();
        })
        .catch(function () { state.busy = false; showError('We could not reach the designer. Please check your connection and try again.'); render(); });
    }

    function addToCart() {
      readFields(); render();
      showError('');
      var min = state.config.amounts.min, max = state.config.amounts.max;
      if (!(state.amount >= min && state.amount <= max)) return showError('Choose an amount from €' + min + ' to €' + max + ', in whole euros.');
      var variant = state.config.variants[String(state.amount)];
      if (!variant) return showError('This amount is not available right now. Please choose another.');
      if (state.send && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.recipientEmail.trim())) return showError('Please enter the recipient’s email address, or untick "Email the gift card to the recipient".');
      var useAi = state.mode === 'ai' && state.designId;
      var snapshotId = '';
      state.busy = true; render();
      call('/api/finalise', { body: { designId: useAi ? state.designId : undefined, occasion: state.occasion, amount: state.amount,
        greeting: state.greeting, recipientName: state.recipientName, fromName: state.fromName, message: state.message } })
        .then(function (j) {
          if (j._status !== 200) throw new Error(j.message || 'We could not prepare your card. Please try again.');
          snapshotId = j.snapshotId;
          var props = { _design: j.snapshotId };
          if (state.send) {
            props['Recipient email'] = state.recipientEmail.trim();
            if (state.recipientName) props['Recipient name'] = state.recipientName;
            // Shopify's own gift card Message field stops at 200 characters; the card picture
            // carries the full message (up to 300), so a longer one is not sent to Shopify.
            if (state.message && state.message.length <= 200) props['Message'] = state.message;
            if (state.sendOn) props['Send on'] = state.sendOn;
            props['__shopify_offset'] = String(new Date().getTimezoneOffset());
            props['__shopify_send_gift_card_to_recipient'] = 'on';
          }
          return fetch(root.dataset.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variant, quantity: 1, properties: props }] }) })
            .then(function (r) { return r.json().then(function (b) { if (!r.ok) throw new Error(b.description || b.message || 'Could not add to cart.'); return b; }); });
        })
        .then(function () { window.location.href = root.dataset.cartUrl; })
        .catch(function (err) {
          // Another app's script on the page can break after the card is already in the cart
          // (18 Oct 2026: a second click then added a second card). Look in the cart first.
          var inCart = !snapshotId ? Promise.resolve(false) : fetch(root.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { return (cart.items || []).some(function (i) { return i.properties && i.properties._design === snapshotId; }); })
            .catch(function () { return false; });
          inCart.then(function (found) {
            if (found) { window.location.href = root.dataset.cartUrl; return; }
            state.busy = false; showError(err.message); render();
          });
        });
    }

    call('/api/config').then(function (cfg) {
      if (cfg._status !== 200) throw new Error();
      state.config = cfg;
      state.greeting = (occasion() || {}).greeting || '';
      var greetingField = $('[data-field="greeting"]');
      if (!greetingField.value) greetingField.value = state.greeting;
      buildChips(); bind(); readFields(); render();
      if (!token) return;
      return call('/api/quota').then(function (q) {
        state.signedIn = !!q.signedIn; state.left = q.left || 0;
        state.designs = (q.designs || []).map(function (d) { return { designId: d.designId, artUrl: d.artUrl }; });
        render();
      });
    }).catch(function () { showError('The gift card designer is not available right now. Please try again later.'); });
  }
  function boot() { document.querySelectorAll('.msgc').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ms-photo-rail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-photo-rail')) {
    customElements.define('ms-photo-rail', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ms-photo-rail__track');
        if (!this.track) return;
        this.onChange = () => this.update();
        this.track.addEventListener('scroll', this.onChange, { passive: true });
        this.resizeObserver = new ResizeObserver(this.onChange);
        this.resizeObserver.observe(this.track);
        this.querySelectorAll('[data-rail-step]').forEach((button) => {
          button.addEventListener('click', () => {
            const step = Number(button.dataset.railStep) * this.track.clientWidth * 0.8;
            this.track.scrollBy({ left: step, behavior: 'smooth' });
          });
        });
        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const max = Math.max(0, scrollWidth - clientWidth);
        this.style.setProperty('--rail-size', scrollWidth ? Math.min(1, clientWidth / scrollWidth) : 1);
        this.style.setProperty('--rail-pos', max ? scrollLeft / max : 0);
        this.toggleAttribute('data-scrollable', max > 1);
        const [prev, next] = this.querySelectorAll('[data-rail-step]');
        if (prev) prev.disabled = scrollLeft <= 1;
        if (next) next.disabled = scrollLeft >= max - 1;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
